import { Component, HostBinding, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

import { MessageService } from '@services/message.service';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BasicObject, Message } from '../../interfaces/checkout.interface';

@Component({
    selector: 'checkout-notify-errors',
    templateUrl: './notify-errors.component.html',
    styleUrl: 'notify-errors.component.scss',
    standalone: true,
})
export class NotifyErrorsComponent implements OnInit, OnChanges, OnDestroy {
    public errorLevels: string[];
    @Input() errors: Message[];
    public userMessagesByLevel: BasicObject;
    protected unsubscribe$: Subject<boolean> = new Subject<boolean>();

    constructor(private messageService: MessageService) {
        this._resetMessages();
        this.errorLevels = Object.keys(this.userMessagesByLevel);
    }
    @HostBinding('class.is-block')
    get isBlock(): boolean {
        return this.errors?.length > 0;
    }

    public deleteLevelMessage(level: string): void {
        this.userMessagesByLevel[level] = [];
        this.errors.forEach((message: Message, index: number) => {
            if (message.showToUser && message.level === level) {
                this.errors.splice(index, index + 1);
            }
        });
        this.messageService.deleteLevelMessage(level);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (!changes?.errors?.currentValue) {
            this.errors = null;
            return;
        }
        this._handleErrors(this.errors);
    }

    public ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.unsubscribe();
    }

    public ngOnInit(): void {
        this._handleErrors(this.messageService.errors);
        this.messageService.dispatchErrors
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((error) => this._handleErrors([error]));
    }

    private _handleErrors(errors: Message[]): void {
        this.errors = errors;
        if (errors) {
            this._resetMessages();
            errors.forEach((message: Message) => {
                if (message.showToUser) {
                    this.userMessagesByLevel[message.level || MessageService.ERRORS_LEVELS.warning].push(message);
                }
            });
        }
    }

    private _resetMessages(): void {
        this.userMessagesByLevel = {
            [MessageService.ERRORS_LEVELS.warning]: [],
            [MessageService.ERRORS_LEVELS.error]: [],
            [MessageService.ERRORS_LEVELS.info]: [],
        };
    }
}
